var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8226 13.7505C7.62025 13.7505 3.23438 14.9205 3.23438 17.2505V19.0004H16.4108V17.2505C16.4108 14.9205 12.025 13.7505 9.8226 13.7505ZM5.43673 17.0005C6.22732 16.4204 8.1379 15.7505 9.8226 15.7505C11.5073 15.7505 13.4179 16.4204 14.2084 17.0005H5.43673ZM9.8226 12.0005C11.6391 12.0005 13.1167 10.4305 13.1167 8.50048C13.1167 6.57048 11.6391 5.00049 9.8226 5.00049C8.00614 5.00049 6.52849 6.57048 6.52849 8.50048C6.52849 10.4305 8.00614 12.0005 9.8226 12.0005ZM9.8226 7.00048C10.6038 7.00048 11.2344 7.67049 11.2344 8.50048C11.2344 9.33048 10.6038 10.0005 9.8226 10.0005C9.04143 10.0005 8.41084 9.33048 8.41084 8.50048C8.41084 7.67049 9.04143 7.00048 9.8226 7.00048ZM16.4485 13.8105C17.5402 14.6505 18.2932 15.7705 18.2932 17.2505V19.0004H22.0578V17.2505C22.0578 15.2305 18.7638 14.0805 16.4485 13.8105ZM15.4697 12.0005C17.2861 12.0005 18.7638 10.4305 18.7638 8.50048C18.7638 6.57048 17.2861 5.00049 15.4697 5.00049C14.9615 5.00049 14.4908 5.13048 14.0579 5.35048C14.6509 6.24048 14.999 7.33048 14.999 8.50048C14.999 9.67048 14.6509 10.7605 14.0579 11.6505C14.4908 11.8705 14.9615 12.0005 15.4697 12.0005Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersons);
export default __webpack_public_path__ + "static/media/persons.6531620bd7ccea5a30b9f327ec4ac29f.svg";
export { ForwardRef as ReactComponent };